export const navRoutes: { label: string; path: string }[] = [
  { label: "Daily", path: "/" },
  { label: "Library", path: "/library" },
  { label: "Community", path: "/community" },
  { label: "Favorites", path: "/favorites" },
  { label: "Discover", path: "/discover" },
  { label: "Profile", path: "/profile" },
  { label: "Harvest", path: "/harvest" },
];
